import { Row, Button, Box, EmailIcon } from "@hightouch/htui";
import { PropsWithChildren } from "react";
import { GoogleLogo, MicrosoftLogo } from "./logos";

type StyledButtonProps = PropsWithChildren<{
  onClick: () => void;
  icon: React.ReactNode;
}>;

export function StyledButton({ children, icon, onClick }: StyledButtonProps) {
  return (
    <Box as={Button} size="md" onClick={onClick}>
      {icon && (
        <Row
          as="span"
          align="center"
          justify="center"
          color="text.secondary"
          pos="absolute"
          boxSize="20px"
          fontSize="20px"
          lineHeight="normal"
          left={2}
        >
          {icon}
        </Row>
      )}
      {children}
    </Box>
  );
}

type Props = {
  onClick: () => void;
  action: "Log in" | "Sign up";
};

export const GoogleButton = ({ onClick, action }: Props) => (
  <StyledButton icon={<GoogleLogo />} onClick={onClick}>
    {`${action} with Google`}
  </StyledButton>
);

export const MicrosoftButton = ({ onClick, action }: Props) => (
  <StyledButton icon={<MicrosoftLogo />} onClick={onClick}>
    {`${action} with Microsoft`}
  </StyledButton>
);

export const EmailButton = ({ onClick, action }: Props) => (
  <StyledButton icon={<EmailIcon />} onClick={onClick}>
    {`${action} with email`}
  </StyledButton>
);
